import { Component, OnInit } from '@angular/core';
import { DashboardService } from '../dashboard.service';

@Component({
  selector: 'app-type-selection',
  templateUrl: './type-selection.component.html',
  styleUrls: ['./type-selection.component.scss']
})
export class TypeSelectionComponent implements OnInit {
  selectedType: 'NDA' | 'sNDA' | null = null;

  constructor(private dashboardService: DashboardService) {}

  ngOnInit() {
    this.dashboardService.filters$.subscribe(filters => {
      this.selectedType = filters.type || null;
    });
  }

  selectType(type: 'NDA' | 'sNDA') {
    this.selectedType = type;
    this.dashboardService.selectType(type);
  }
}
